import "./src/styles/style.css";
import type { ShouldUpdateScrollArgs } from "gatsby";
// gatsby-browser.tsx

import type { GatsbyBrowser } from "gatsby";

export const shouldUpdateScroll: GatsbyBrowser["shouldUpdateScroll"] = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  const hash = location.hash;
  const savedPosition = getSavedScrollPosition(location);

  setTimeout(() => {
    if (hash) {
      // scroll to element with id matching hash
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }

    // fallback: scroll to saved position or top
    window.scrollTo(...(savedPosition || [0, 0]));
  }, 0);

  return false; // prevent Gatsby default scroll handling
};
